// extracted by mini-css-extract-plugin
export default {"steps":"_2vrwMuyw","greyDot":"cOZIYhrR","stepText":"_1-dqfG9w"};